import { fork, takeEvery, all } from 'redux-saga/effects';
import config from '../../../config/config';
import {
  InventoryApi,
  InventoryControllerDtoItemGroupListRequest,
  InventoryControllerDtoItemRemoveRequest,
} from '../../models/src';
import { getErrorMessage } from '../../../utils/serverErrorCheck';
import BaseResponse from '../../models/src/model/BaseResponse';
import {
  USER_ITEM_ITEM_LIST_REQUEST,
  USER_ITEM_ITEM_REMOVE_REQUEST
} from '../../constants/app/userItemManageConstants';
import InventoryControllerDtoGetItemGroupListResponse
  from '../../models/src/model/InventoryControllerDtoItemGroupListResponse';

const api = new InventoryApi(config.API_CLIENT);

function* userItemListRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new InventoryControllerDtoItemGroupListRequest();
    requestData.searchString = payload.searchString;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiInventoryGetItemGroupListPost({ inventoryControllerDtoItemGroupListRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, InventoryControllerDtoGetItemGroupListResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* itemRemoveRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new InventoryControllerDtoItemRemoveRequest();
    requestData.itemId = payload.itemId;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiInventoryRemoveItemPost({ inventoryControllerDtoItemRemoveRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, BaseResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* userItemManageRootSaga() {
  yield all([
    takeEvery(USER_ITEM_ITEM_LIST_REQUEST, userItemListRequestSaga),
    takeEvery(USER_ITEM_ITEM_REMOVE_REQUEST, itemRemoveRequestSaga),
  ]);
}

const userItemManageSagas = [
  fork(userItemManageRootSaga),
];

export default userItemManageSagas;
